import * as React from 'react';

import { TgbAsideBannerContainer } from '../../containers/Adfox/TgbAsideBannerContainer';
import * as styles from './index.css';

export interface IAsideBannersStoreProps {
  height: number;
}

const BANNER_HEIGHT = 200;
const MIN_BANNERS_COUNT = 1;
const MAX_BANNERS_COUNT = 3;

export const AsideBanners: React.FC<IAsideBannersStoreProps> = ({ height }) => {
  const bannersCount = React.useMemo(() => getBannersCount(height), [height]);

  if (!bannersCount) {
    return null;
  }

  return (
    <div className={styles['container']}>
      {[...Array(bannersCount)].map((_, index) => {
        return <TgbAsideBannerContainer key={`banner_${index}`} />;
      })}
    </div>
  );
};

function getBannersCount(height: number) {
  if (!height) {
    return 0;
  }

  const viewportHeight = window.innerHeight;
  const bannersCount = Math.floor((viewportHeight - height) / BANNER_HEIGHT);

  return Math.min(MAX_BANNERS_COUNT, Math.max(MIN_BANNERS_COUNT, bannersCount));
}
